import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4ed64ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gallery-container" }
const _hoisted_2 = {
  key: 0,
  class: "gallery-grid"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  src: "/img/not_found.jpg",
  alt: "Cargando...",
  class: "gallery-img placeholder-blur"
}
const _hoisted_6 = {
  key: 2,
  class: "camera-tag-badge"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gallery-item-hover" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Seleccionar")
], -1))
const _hoisted_8 = { class: "pagination-trigger-zone" }
const _hoisted_9 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Buscando imágenes...", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "load-more-wrapper"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Cargar más imágenes ")
const _hoisted_14 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_15 = { class: "gallery-footer" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Confirmar Selección ")

import { ref, onMounted, onUnmounted, watch } from "vue";
import { ElMessage } from "element-plus";
import { Image } from "@/types/Image.type";
import { getImage, getImagesByDateIncremental } from "@/service/image.service";


export default /*#__PURE__*/_defineComponent({
  props: {
    samplingPointId: null,
    stationId: null
  },
  emits: ["selected", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: "selected", imageData: { id: number; url: string; camera: string }): void;
  (e: "cancel"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  samplingPointId: number;
  stationId: string;
}





const imagesList = ref<Image[]>([]);
const src = ref<{ [name: string]: string }>({});
const loading = ref<boolean>(false);
const hasMore = ref<boolean>(false);

const lastDate = ref<string | undefined>(undefined);
const TAKE = 10;

const thumbnail = false;

onMounted(async () => {
  await initSearch();
});

onUnmounted(() => {
  clearBinarySources();
});

const clearBinarySources = () => {
  Object.values(src.value).forEach((value) => URL.revokeObjectURL(value));
  src.value = {};
};

const safeToISOString = (dateTime: any): string | undefined => {
  if (!dateTime) return undefined;
  const date = new Date(dateTime);
  return isNaN(date.getTime()) ? undefined : date.toISOString();
};

const isoMinusOneMs = (isoString: string | undefined): string | undefined => {
  if (!isoString) return undefined;
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return undefined;
  return new Date(date.getTime() - 1).toISOString();
};

const initSearch = async () => {
  if (!props.stationId) return;

  loading.value = true;
  imagesList.value = [];
  clearBinarySources();
  lastDate.value = undefined;
  hasMore.value = true;

  try {
    const data = await getImagesByDateIncremental(
      `${props.stationId}`,
      undefined,
      false,
      undefined,
      undefined,
      undefined,
      "ALL"
    );

    const newImages = Array.isArray(data) ? data : [];

    newImages.sort((a: any, b: any) => {
      const aIso = safeToISOString(a.dateTime) ?? "";
      const bIso = safeToISOString(b.dateTime) ?? "";
      return bIso.localeCompare(aIso);
    });

    imagesList.value = newImages;

    if (newImages.length > 0) {
      lastDate.value = safeToISOString(newImages[newImages.length - 1].dateTime);
    }

    await loadBinaryImages(newImages);

    hasMore.value = newImages.length === TAKE;
  } catch (error) {
    hasMore.value = false;
    ElMessage.warning("No se encontraron imágenes en la galería");
  } finally {
    loading.value = false;
  }
};

const showMoreImages = async () => {
  if (loading.value || !hasMore.value || !lastDate.value) return;

  loading.value = true;
  try {
    const fromCursor = isoMinusOneMs(lastDate.value);

    const data = await getImagesByDateIncremental(
      `${props.stationId}`,
      fromCursor,
      true,
      undefined,
      undefined,
      undefined,
      "ALL"
    );

    const newImages = Array.isArray(data) ? data : [];

    if (newImages.length === 0) {
      hasMore.value = false;
      return;
    }

    newImages.sort((a: any, b: any) => {
      const aIso = safeToISOString(a.dateTime) ?? "";
      const bIso = safeToISOString(b.dateTime) ?? "";
      return bIso.localeCompare(aIso);
    });

    const serverLastDate = safeToISOString(newImages[newImages.length - 1].dateTime);

    if (serverLastDate && serverLastDate === lastDate.value) {
      hasMore.value = false;
      return;
    }

    const combined = [...imagesList.value, ...newImages];
    imagesList.value = combined.filter(
      (img, index, self) => self.findIndex((i) => i.id === img.id) === index
    );

    if (serverLastDate) {
      lastDate.value = serverLastDate;
    }

    await loadBinaryImages(newImages);

    hasMore.value = newImages.length === TAKE;
  } catch (error) {
    console.error("Error cargando más imágenes:", error);
    hasMore.value = false;
  } finally {
    loading.value = false;
  }
};

const loadBinaryImages = async (images: Image[]) => {
  images.forEach((image) => {
    if (image?.fileName && !src.value[image.fileName]) {
      getImage(image.fileName, thumbnail)
        .then((res) => {
          if (image && image.fileName) {
            src.value[image.fileName] = res;
          }
        })
        .catch(() => {
          // -
        });
    }
  });
};

const selectedId = ref<number | null>(null);
const selectedImageRaw = ref<Image | null>(null);

const selectImage = (img: Image) => {
  selectedId.value = img.id || null;
  selectedImageRaw.value = img;
};

const confirmSelection = () => {
  if (selectedImageRaw.value && selectedImageRaw.value.id && selectedImageRaw.value.fileName) {
    const finalUrl = src.value[selectedImageRaw.value.fileName];
    emit("selected", {
      id: selectedImageRaw.value.id,
      url: finalUrl || "",
      camera: selectedImageRaw.value.camera || "",
    });
  }
};

const cancelAction = () => {
  emit("cancel");
};

watch(
  () => [props.samplingPointId, props.stationId],
  () => {
    initSearch();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (imagesList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagesList.value, (img) => {
            return (_openBlock(), _createElementBlock("div", {
              key: img.id || 0,
              class: _normalizeClass(["gallery-item", { 'is-selected': selectedId.value === img.id }]),
              onClick: ($event: any) => (selectImage(img))
            }, [
              (img?.fileName && src.value[img.fileName])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: src.value[img.fileName],
                    alt: img.fileName,
                    class: _normalizeClass(['gallery-img', img.camera])
                  }, null, 10, _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5)),
              (img?.camera)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_el_tag, {
                      type: 'primary',
                      size: "small",
                      effect: "dark"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(img.camera), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_7
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (loading.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)), [
            [_directive_loading, loading.value]
          ])
        : _createCommentVNode("", true),
      (hasMore.value && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              type: "info",
              plain: "",
              size: "small",
              onClick: showMoreImages
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (imagesList.value.length === 0 && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_el_empty, { description: "No hay imágenes disponibles en la galería" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_button, { onClick: cancelAction }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !selectedImageRaw.value,
        onClick: confirmSelection
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})